/**
 * Do not edit directly
 * Generated on Fri, 12 Dec 2025 05:03:13 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";